import { Router, ActivatedRoute } from '@angular/router';
import { WalletService } from '../../services/wallet.service';
import { Component, OnInit } from '@angular/core';
import { MdDialog, MdDialogRef } from '@angular/material';
import { SendMessageComponent } from '../send-message/send-message.component';
import {NgbTabChangeEvent} from '@ng-bootstrap/ng-bootstrap';
import { MessagingService } from '../../services/messaging.service';
import { JobOffersService } from '../../services/job-offers.service';
import { MessageBoxDialog } from '../message-box/message-box.component';
import {Pagination} from '../../models/message';
import { ApplyStatusService } from '../../services/apply-status.service';
import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'angular-2-dropdown-multiselect';
import {Observable} from 'rxjs';

@Component({
  selector: 'app-wallet',
  templateUrl: './wallet.component.html',
  styleUrls: ['./wallet.component.css']
})
export class WalletComponent implements OnInit {
  selectedOption: string;
  loading: boolean;
  user: any;
  userId: string;
  errorMessage: string;
  req: number;

  optionsModel: number[];
  myOptions: IMultiSelectOption[];


  mySettings: IMultiSelectSettings = {
      enableSearch: false,
      checkedStyle: 'glyphicon',
      buttonClasses: 'btn btn-default btn-block',
      dynamicTitleMaxItems: 10,
      displayAllSelectedText: true
  };

myTexts: IMultiSelectTexts = {
      checkAll: 'Seleccionar Todos',
      uncheckAll: 'Remover Todos',
      checked: 'Estado Seleccionado',
      checkedPlural: 'Estados Seleccionados',
      searchPlaceholder: 'Buscar',
      defaultTitle: 'Seleccionar Estado',
      allSelected: 'Seleccionar Todos',
  };

  constructor(public dialog: MdDialog,
    public walletService: WalletService,
    private router: Router,
    private route: ActivatedRoute,

  ) { }

  ngOnInit() {

    this.route.params.subscribe(params => {
      this.userId = params['jobId'];
      if (typeof this.userId != 'undefined') {
        this.searchWallets();
      }
    });
  }

  onChange($event) {
  }



  showDetailsMessage(title, content) {
      this.dialog.open(MessageBoxDialog, {data: {title: title, message: content, alert:true, showIcon:false}});
  }

  searchWallets() {

    this.loading = true;

    let wallets;

      wallets = this.walletService.getUsercheck(this.userId);

    wallets.subscribe(
      data => {
        console.log(data);
          this.user = data;
          this.loading = false;
      },
      error => {
          console.log(error);
          this.loading = false;
      }
    );
  }



  clickCertkWork(id, status:number) {
    this.walletService.postUsercheck(id, 'work', status).subscribe(
      res => {
        this.searchWallets();
      },
      error => {
        console.log(error);
      }
    );

  }

  clickCertEdu(id, status: number) {
    this.walletService.postUsercheck(id, 'edu', status).subscribe(
      res => {
        this.searchWallets();
      },
      error => {
        console.log(error);
      }
    );
  }

  clickCertProfile(id, status: number) {
    this.walletService.postUsercheck(id, 'profile', status).subscribe(
      res => {
        this.searchWallets();
      },
      error => {
        console.log(error);
      }
    );
  }

  showInformation() {
    this.dialog.open(MessageBoxDialog, {data: {message: 'Podrás ver el estado de los mensajes enviados a los candidatos de forma individual o masiva, recuerda que este modulo solo te podrá informar si el candidato leyó o no el mensaje enviado. Los mensajes solo funcionan de forma unilateral lo cual imposibilita al candidato responder por medio de la aplicación móvil.', information: true, showIcon: true}});
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/wallet/wallet.component.ts